import { SVGProps, Ref, forwardRef } from 'react';

export const AdjustmentsOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.8 7c0-.733.187-1.272.458-1.598C6.48 5.135 6.933 4.8 8 4.8s1.52.335 1.742.602c.271.326.458.865.458 1.598s-.187 1.272-.458 1.598C9.52 8.865 9.067 9.2 8 9.2s-1.52-.335-1.742-.602C5.987 8.272 5.8 7.733 5.8 7m-1.728-.9C4.348 4.441 5.453 3 8 3s3.652 1.441 3.928 3.1H23v1.8H11.928C11.652 9.56 10.546 11 8 11S4.348 9.559 4.072 7.9H1V6.1zM16 13c2.547 0 3.652 1.441 3.928 3.1H23v1.8h-3.072C19.652 19.56 18.547 21 16 21s-3.652-1.441-3.928-3.1H1v-1.8h11.072C12.348 14.441 13.453 13 16 13m-1.742 2.402c-.271.326-.458.865-.458 1.598s.187 1.272.458 1.598c.223.267.675.602 1.742.602s1.52-.335 1.742-.602c.271-.326.458-.865.458-1.598s-.187-1.272-.458-1.598c-.223-.267-.675-.602-1.742-.602s-1.52.335-1.742.602"
                fill="currentColor"
            />
        </g>
    </svg>
));
AdjustmentsOutlinedSize24Glyph.displayName = 'AdjustmentsOutlinedSize24Glyph';
